// extracted by mini-css-extract-plugin
module.exports = {"dialogReservation":"DialogReservation_dialogReservation_1sDd_"};